var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63808 17.1425V6.08796M8.35163 5.42479C8.48849 5.4555 8.6327 5.41786 8.73123 5.31933C8.82976 5.2208 8.86735 5.07654 8.83669 4.93973C8.71386 4.43799 8.26139 2.75788 7.79679 2.29328C7.21796 1.71444 6.27587 1.71203 5.6999 2.288C5.12397 2.86393 5.1263 3.80602 5.70518 4.38489C6.17738 4.8571 7.8499 5.30198 8.35163 5.42479ZM9.7565 4.93969C9.72579 5.07655 9.76343 5.22076 9.86196 5.31929C9.96049 5.41782 10.1048 5.45541 10.2416 5.42476C10.7433 5.30192 12.4234 4.84946 12.888 4.38485C13.4669 3.80602 13.4693 2.86394 12.8933 2.28796C12.3174 1.71203 11.3753 1.71436 10.7964 2.29324C10.3242 2.76544 9.87932 4.43796 9.7565 4.93969ZM2.45263 9.95706H16.5472C16.8524 9.95706 17.0999 9.70959 17.0999 9.40433V6.64069C17.0999 6.33543 16.8524 6.08796 16.5472 6.08796H2.45263C2.14737 6.08796 1.8999 6.33543 1.8999 6.64069V9.40433C1.8999 9.70959 2.14737 9.95706 2.45263 9.95706ZM15.7181 9.95706V16.5898C15.7181 16.895 15.4706 17.1425 15.1654 17.1425H3.83445C3.52918 17.1425 3.28172 16.895 3.28172 16.5898V9.95706H15.7181Z",
    stroke: "#7C7C7C",
    strokeWidth: 1.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIcon);
export default __webpack_public_path__ + "static/media/gift-icon.aa360a8b0de11dfd80d911ee759ea5cb.svg";
export { ForwardRef as ReactComponent };